import { IComplianceCoverReview, IShipmentInfo } from 'types'
import { Maybe } from 'types/FMSGraphqlTypes'

export type IShipment = {
  complianceCoverReviews: Pick<
    IComplianceCoverReview,
    'approvedAt' | 'carrierApplicationId' | 'deletedAt'
  >[]
  info: Pick<IShipmentInfo, 'carrierId'>
}

/**
 *
 * @returns Whether or not the carrier is approved to book the shipment by Compliance
 */
export const isCarrierComplianceApprovedForShipment = (shipment: Maybe<IShipment>): boolean => {
  const { complianceCoverReviews = [], info } = shipment || {}
  const { carrierId } = info || {}

  return (
    // finding an approvedAt record in complianceCoverReviews
    // indicates that carrier is manually marked as compliant
    Boolean(
      complianceCoverReviews.find(review => {
        const { approvedAt, carrierApplicationId, deletedAt } = review || {}
        return carrierApplicationId === Number(carrierId) && !!approvedAt && !deletedAt
      })
    )
  )
}
